export const customerProfileMenu = [
  {
    id: 1,
    label: "Profile",
    link: "account-details",
    isRequiredBusiness: false,
  },
  {
    id: 2,
    label: "Billing",
    link: "billing-reports",
    isRequiredBusiness: false,
  },
  {
    id: 4,
    label: "Team",
    link: "team",
    isRequiredBusiness: false,
  },
];
